export const  deliverables = [
    {
      "ProjectUID": "1c019995-1e74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1c019995-1e74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1c019995-1e74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dd23ed0a-1f74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dd23ed0a-1f74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dd23ed0a-1f74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ea4f48ae-2274-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ea4f48ae-2274-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ea4f48ae-2274-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "64d66bf0-2a74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "64d66bf0-2a74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "64d66bf0-2a74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f7ba5736-2c74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f7ba5736-2c74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f7ba5736-2c74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1230f0c3-2d74-eb11-8af0-005056921d78",
      "Title": "توريد نظام إدارة المراجعة الداخلية",
      "StartDate": "2021-10-31T00:00:00",
      "FinishDate": "2021-11-11T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1230f0c3-2d74-eb11-8af0-005056921d78",
      "Title": "التركيب والإطلاق الكامل للنظام ",
      "StartDate": "2021-11-14T00:00:00",
      "FinishDate": "2021-12-09T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1230f0c3-2d74-eb11-8af0-005056921d78",
      "Title": "تقديم الدعم الفني",
      "StartDate": "2021-10-31T00:00:00",
      "FinishDate": "2023-10-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af6d183f-2f74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af6d183f-2f74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af6d183f-2f74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7570ed02-3274-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7570ed02-3274-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7570ed02-3274-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c495c538-3974-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c495c538-3974-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c495c538-3974-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebba6e15-3b74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebba6e15-3b74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebba6e15-3b74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "390d09ce-3b74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "390d09ce-3b74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "390d09ce-3b74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3d988bf2-5074-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3d988bf2-5074-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3d988bf2-5074-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "Title": "نظام لادارة الوثائق",
      "StartDate": "2021-05-18T00:00:00",
      "FinishDate": "2024-05-18T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "Title": "مقر مخصص للوثائق",
      "StartDate": "2021-05-18T00:00:00",
      "FinishDate": "2024-05-18T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "Title": "ترحيل الوثائق ",
      "StartDate": "2021-05-18T00:00:00",
      "FinishDate": "2024-05-18T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3983d67-6574-eb11-8af0-005056921d78",
      "Title": "تحويل ومعالجة الى الصيغة الرقمية ل 10 مليون وثيقة الصيغة الرقمية وفهرستها",
      "StartDate": "2021-05-18T00:00:00",
      "FinishDate": "2024-05-18T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "تطوير مكتب ادارة المشاريع",
      "StartDate": "2021-11-02T00:00:00",
      "FinishDate": "2021-11-05T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "دراسة الوضع الراهن",
      "StartDate": "2020-10-11T00:00:00",
      "FinishDate": "2021-10-02T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "التدريب ونقل المعرفة",
      "StartDate": "2021-12-05T00:00:00",
      "FinishDate": "2021-12-11T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8fbe459c-6b74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "085d106c-6c74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "085d106c-6c74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "085d106c-6c74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c1be9aaf-6d74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c1be9aaf-6d74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c1be9aaf-6d74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2e17b14-6f74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2e17b14-6f74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2e17b14-6f74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5c8b21da-6f74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5c8b21da-6f74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5c8b21da-6f74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0771a8ce-7374-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0771a8ce-7374-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0771a8ce-7374-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b5a39ea6-7474-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b5a39ea6-7474-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b5a39ea6-7474-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "83f8ec0e-7674-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "83f8ec0e-7674-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "83f8ec0e-7674-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "77d44a8b-7674-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "77d44a8b-7674-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "77d44a8b-7674-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c6e23b3-7874-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c6e23b3-7874-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c6e23b3-7874-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "Title": "تقرير نتائج المراجعة",
      "StartDate": "2021-12-12T00:00:00",
      "FinishDate": "2021-12-16T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "Title": "التقييم المبدئي",
      "StartDate": "2021-10-03T00:00:00",
      "FinishDate": "2021-10-14T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "Title": "مرحلة التخطيط للمراجعة",
      "StartDate": "2021-09-08T00:00:00",
      "FinishDate": "2021-09-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "Title": "مرحلة العمل الميداني",
      "StartDate": "2021-10-17T00:00:00",
      "FinishDate": "2021-12-02T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "76f78015-8274-eb11-8af0-005056921d78",
      "Title": "تقرير بالملاحظات الأولية",
      "StartDate": "2021-12-05T00:00:00",
      "FinishDate": "2021-12-09T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "62f10be3-8274-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "62f10be3-8274-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "62f10be3-8274-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6dc18cb3-8374-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6dc18cb3-8374-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6dc18cb3-8374-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "56495302-8474-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "56495302-8474-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "56495302-8474-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d22444e-8574-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d22444e-8574-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d22444e-8574-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "622b1d20-8674-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "622b1d20-8674-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "622b1d20-8674-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb43ec17-8774-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb43ec17-8774-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb43ec17-8774-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4df58b8a-8874-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4df58b8a-8874-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4df58b8a-8874-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "07e4f787-8974-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "07e4f787-8974-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "07e4f787-8974-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "93c4effd-8974-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "93c4effd-8974-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "93c4effd-8974-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ec7ee3e4-8d74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ec7ee3e4-8d74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ec7ee3e4-8d74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f704c371-b574-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f704c371-b574-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f704c371-b574-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b502d22f-bf74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b502d22f-bf74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b502d22f-bf74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d984262-c274-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d984262-c274-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6d984262-c274-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d4877129-c374-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d4877129-c374-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d4877129-c374-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bbd591b0-c674-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87fcd659-c974-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87fcd659-c974-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87fcd659-c974-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f9f9ad6-c974-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f9f9ad6-c974-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f9f9ad6-c974-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4b70164d-ca74-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4b70164d-ca74-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4b70164d-ca74-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b1d0ffcc-d174-eb11-8af0-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b1d0ffcc-d174-eb11-8af0-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b1d0ffcc-d174-eb11-8af0-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4d9531e1-f074-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4d9531e1-f074-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4d9531e1-f074-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac1650d6-f174-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac1650d6-f174-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac1650d6-f174-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6fb4fc1e-f574-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6fb4fc1e-f574-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6fb4fc1e-f574-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "807c599e-f574-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "807c599e-f574-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "807c599e-f574-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9fe464d1-fc74-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9fe464d1-fc74-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9fe464d1-fc74-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90771740-fd74-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90771740-fd74-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90771740-fd74-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87b3ddbd-fd74-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87b3ddbd-fd74-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "87b3ddbd-fd74-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c3aaf378-ff74-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c3aaf378-ff74-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c3aaf378-ff74-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "287b41e3-0175-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "19bbe9df-0375-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "19bbe9df-0375-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "19bbe9df-0375-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a52bef22-1275-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a52bef22-1275-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a52bef22-1275-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "638f41d8-1975-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "638f41d8-1975-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "638f41d8-1975-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "46f1405a-1d75-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "46f1405a-1d75-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "46f1405a-1d75-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7790b2de-1e75-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7790b2de-1e75-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7790b2de-1e75-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2bf0174-2375-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2bf0174-2375-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a2bf0174-2375-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b80b1dc8-2475-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b80b1dc8-2475-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b80b1dc8-2475-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68e05623-2a75-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68e05623-2a75-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68e05623-2a75-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8af99b70-2b75-eb11-8af1-005056921d78",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8af99b70-2b75-eb11-8af1-005056921d78",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8af99b70-2b75-eb11-8af1-005056921d78",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "21db326f-04af-43f0-ac80-005199b779b1",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "21db326f-04af-43f0-ac80-005199b779b1",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "21db326f-04af-43f0-ac80-005199b779b1",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1e2c0a48-bdfb-4f60-a14c-023877dc4dc8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1e2c0a48-bdfb-4f60-a14c-023877dc4dc8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1e2c0a48-bdfb-4f60-a14c-023877dc4dc8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6671c86b-cc7a-4601-accf-06ce4343646a",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6671c86b-cc7a-4601-accf-06ce4343646a",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6671c86b-cc7a-4601-accf-06ce4343646a",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5eca63de-53a0-456f-9d3e-0bab39db0486",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5eca63de-53a0-456f-9d3e-0bab39db0486",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5eca63de-53a0-456f-9d3e-0bab39db0486",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "37ca1e70-8cc5-47d9-ac76-0c3d0ad157ab",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "37ca1e70-8cc5-47d9-ac76-0c3d0ad157ab",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "37ca1e70-8cc5-47d9-ac76-0c3d0ad157ab",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "971083e2-4c88-4b1f-b16b-102c912f0516",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "971083e2-4c88-4b1f-b16b-102c912f0516",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "971083e2-4c88-4b1f-b16b-102c912f0516",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "82363c9f-09b6-4778-90f7-1078132cd323",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "82363c9f-09b6-4778-90f7-1078132cd323",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "82363c9f-09b6-4778-90f7-1078132cd323",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0aae1674-948c-43b9-98ac-11bc5a950fc5",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0aae1674-948c-43b9-98ac-11bc5a950fc5",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0aae1674-948c-43b9-98ac-11bc5a950fc5",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "59cfad33-0a1b-4e4b-8176-14904de56dbc",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "59cfad33-0a1b-4e4b-8176-14904de56dbc",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "59cfad33-0a1b-4e4b-8176-14904de56dbc",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6735b519-dc25-4989-b19d-14dd158e9118",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6735b519-dc25-4989-b19d-14dd158e9118",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6735b519-dc25-4989-b19d-14dd158e9118",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1f237860-9752-44eb-99db-14ee2bad75f4",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1f237860-9752-44eb-99db-14ee2bad75f4",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1f237860-9752-44eb-99db-14ee2bad75f4",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98875ebe-ff9a-4572-8eef-154ee988a671",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98875ebe-ff9a-4572-8eef-154ee988a671",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98875ebe-ff9a-4572-8eef-154ee988a671",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cc69148b-0c82-495d-80df-16a434a13c84",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cc69148b-0c82-495d-80df-16a434a13c84",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cc69148b-0c82-495d-80df-16a434a13c84",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "842b0843-b0ce-421f-a8a3-16b8119d1c61",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "842b0843-b0ce-421f-a8a3-16b8119d1c61",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "842b0843-b0ce-421f-a8a3-16b8119d1c61",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ef35725a-fd8a-419a-8ef8-17157619590b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ef35725a-fd8a-419a-8ef8-17157619590b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ef35725a-fd8a-419a-8ef8-17157619590b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "89ba109e-0c1c-4661-abc2-1c3d9efe86a5",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "89ba109e-0c1c-4661-abc2-1c3d9efe86a5",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "89ba109e-0c1c-4661-abc2-1c3d9efe86a5",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b76b6236-1f27-4d76-8ad3-1c3facd1c0e7",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b76b6236-1f27-4d76-8ad3-1c3facd1c0e7",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b76b6236-1f27-4d76-8ad3-1c3facd1c0e7",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "58536f23-0558-4a0b-900d-1d0859d18c96",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "58536f23-0558-4a0b-900d-1d0859d18c96",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "58536f23-0558-4a0b-900d-1d0859d18c96",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4bb60aa5-5656-47da-9d2d-1def75560125",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4bb60aa5-5656-47da-9d2d-1def75560125",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4bb60aa5-5656-47da-9d2d-1def75560125",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5475eb06-556b-4dec-b2d6-1e5c53aaf23b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5475eb06-556b-4dec-b2d6-1e5c53aaf23b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5475eb06-556b-4dec-b2d6-1e5c53aaf23b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af9f6a19-83a4-4247-99cf-204635287888",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af9f6a19-83a4-4247-99cf-204635287888",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "af9f6a19-83a4-4247-99cf-204635287888",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7edbeff4-17a1-4df3-850a-20f15980892f",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7edbeff4-17a1-4df3-850a-20f15980892f",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7edbeff4-17a1-4df3-850a-20f15980892f",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b367caac-211e-42fe-b1e6-2151d8ab0013",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b367caac-211e-42fe-b1e6-2151d8ab0013",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b367caac-211e-42fe-b1e6-2151d8ab0013",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f67c880-745f-4303-b83d-22741c204742",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f67c880-745f-4303-b83d-22741c204742",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f67c880-745f-4303-b83d-22741c204742",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d0f5d29-37bb-479b-87be-238dad714e1e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d0f5d29-37bb-479b-87be-238dad714e1e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d0f5d29-37bb-479b-87be-238dad714e1e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df3cdbf2-e0fe-4d5e-b084-24a3aadc5b80",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df3cdbf2-e0fe-4d5e-b084-24a3aadc5b80",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df3cdbf2-e0fe-4d5e-b084-24a3aadc5b80",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "94bf2681-9069-43d1-a6bf-25894ca82a37",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "94bf2681-9069-43d1-a6bf-25894ca82a37",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "94bf2681-9069-43d1-a6bf-25894ca82a37",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6bee3a30-7fd6-4825-ac3f-259f160779f2",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6bee3a30-7fd6-4825-ac3f-259f160779f2",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6bee3a30-7fd6-4825-ac3f-259f160779f2",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b39d1331-4795-4805-b5b7-25b4fa66169f",
      "Title": "مركزة  معالجة الأمانات نقل مهام عمليات التمويل الاجتماعي إلى العمليات البنكية",
      "StartDate": "2021-01-03T00:00:00",
      "FinishDate": "2021-08-31T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "de03f0f4-ecf2-4e5d-994f-25bf76b70552",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "de03f0f4-ecf2-4e5d-994f-25bf76b70552",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "de03f0f4-ecf2-4e5d-994f-25bf76b70552",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "79ffeeb4-fb3d-4259-95a0-26124c4945f2",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "79ffeeb4-fb3d-4259-95a0-26124c4945f2",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "79ffeeb4-fb3d-4259-95a0-26124c4945f2",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2d0c54b-a579-476b-8dda-2663c1f4a531",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2d0c54b-a579-476b-8dda-2663c1f4a531",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2d0c54b-a579-476b-8dda-2663c1f4a531",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3e9243b1-0491-4b77-8e8d-268e452d661b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3e9243b1-0491-4b77-8e8d-268e452d661b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3e9243b1-0491-4b77-8e8d-268e452d661b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9af73c7e-dbcc-4c80-a3bc-289bd52d340e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9af73c7e-dbcc-4c80-a3bc-289bd52d340e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9af73c7e-dbcc-4c80-a3bc-289bd52d340e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5ba5be6e-2742-4fcf-ab11-2ca4daf2532b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5ba5be6e-2742-4fcf-ab11-2ca4daf2532b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5ba5be6e-2742-4fcf-ab11-2ca4daf2532b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68eefdee-ea2e-40fa-9746-2d4832b22411",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68eefdee-ea2e-40fa-9746-2d4832b22411",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "68eefdee-ea2e-40fa-9746-2d4832b22411",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4375743-5d39-43b7-92fb-2d7c64d51d60",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4375743-5d39-43b7-92fb-2d7c64d51d60",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4375743-5d39-43b7-92fb-2d7c64d51d60",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e52bbf63-34b7-4976-b343-2dd452faa2fe",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e52bbf63-34b7-4976-b343-2dd452faa2fe",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e52bbf63-34b7-4976-b343-2dd452faa2fe",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9f4956d3-3593-4d98-86e7-2e4be207b8c8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9f4956d3-3593-4d98-86e7-2e4be207b8c8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9f4956d3-3593-4d98-86e7-2e4be207b8c8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cea6571b-7d45-4508-9cda-325c806352f6",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cea6571b-7d45-4508-9cda-325c806352f6",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cea6571b-7d45-4508-9cda-325c806352f6",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "117059bb-b6a1-43c0-b1bd-329cee5858a8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "117059bb-b6a1-43c0-b1bd-329cee5858a8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "117059bb-b6a1-43c0-b1bd-329cee5858a8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d8f954b8-912f-411d-b844-33016ba8d879",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d8f954b8-912f-411d-b844-33016ba8d879",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d8f954b8-912f-411d-b844-33016ba8d879",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "09543f86-1607-4425-b538-374e70e0d1c0",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "09543f86-1607-4425-b538-374e70e0d1c0",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "09543f86-1607-4425-b538-374e70e0d1c0",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3c82bbd6-b5ce-41c5-aeb1-3bb5993cbd09",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3c82bbd6-b5ce-41c5-aeb1-3bb5993cbd09",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3c82bbd6-b5ce-41c5-aeb1-3bb5993cbd09",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "108f1ad0-e93d-41d6-9331-3c9d97f425dc",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "108f1ad0-e93d-41d6-9331-3c9d97f425dc",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "108f1ad0-e93d-41d6-9331-3c9d97f425dc",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7dbec7a5-6ee3-4b11-b7f5-3f794de777bc",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7dbec7a5-6ee3-4b11-b7f5-3f794de777bc",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7dbec7a5-6ee3-4b11-b7f5-3f794de777bc",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5450d71c-f998-4c9c-a46d-3faab8a47ded",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5450d71c-f998-4c9c-a46d-3faab8a47ded",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5450d71c-f998-4c9c-a46d-3faab8a47ded",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f944f4f0-1fdb-4e09-b210-4046532eb624",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f944f4f0-1fdb-4e09-b210-4046532eb624",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f944f4f0-1fdb-4e09-b210-4046532eb624",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dfd277e7-780e-4581-83a1-4260f09c90df",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dfd277e7-780e-4581-83a1-4260f09c90df",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "dfd277e7-780e-4581-83a1-4260f09c90df",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1addafe8-9b85-4d27-9499-44becf5b3f75",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1addafe8-9b85-4d27-9499-44becf5b3f75",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1addafe8-9b85-4d27-9499-44becf5b3f75",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "baf3f62e-cb63-453a-bb95-4661d2468e28",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "baf3f62e-cb63-453a-bb95-4661d2468e28",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "baf3f62e-cb63-453a-bb95-4661d2468e28",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cb0439ce-a7fd-45f5-844f-4bb35dd4c957",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cb0439ce-a7fd-45f5-844f-4bb35dd4c957",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "cb0439ce-a7fd-45f5-844f-4bb35dd4c957",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df50063e-8cfc-4816-9a9c-4d8274dd00b2",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df50063e-8cfc-4816-9a9c-4d8274dd00b2",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df50063e-8cfc-4816-9a9c-4d8274dd00b2",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c2bdad9c-9c0a-457a-a94c-4df4821f1241",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c2bdad9c-9c0a-457a-a94c-4df4821f1241",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c2bdad9c-9c0a-457a-a94c-4df4821f1241",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "acd3afc1-bd0f-4c6f-b136-4e6c4d1db7eb",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "acd3afc1-bd0f-4c6f-b136-4e6c4d1db7eb",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "acd3afc1-bd0f-4c6f-b136-4e6c4d1db7eb",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "774bb06d-63fd-435c-8b27-4fa75a26cb5d",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "774bb06d-63fd-435c-8b27-4fa75a26cb5d",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "774bb06d-63fd-435c-8b27-4fa75a26cb5d",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5e93c1bc-c5c3-4386-92a3-513c34e99ca0",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5e93c1bc-c5c3-4386-92a3-513c34e99ca0",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "5e93c1bc-c5c3-4386-92a3-513c34e99ca0",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7f8a6315-d214-415f-b136-56f06aad6f9f",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7f8a6315-d214-415f-b136-56f06aad6f9f",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7f8a6315-d214-415f-b136-56f06aad6f9f",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "78120924-a6f2-427d-9a6e-585f69ddb40c",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "78120924-a6f2-427d-9a6e-585f69ddb40c",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "78120924-a6f2-427d-9a6e-585f69ddb40c",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b7308c2a-d4d0-45d4-98b6-5c6022c31205",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b7308c2a-d4d0-45d4-98b6-5c6022c31205",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b7308c2a-d4d0-45d4-98b6-5c6022c31205",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e86ee505-8d8d-461d-a758-5d2296c2b4a0",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e86ee505-8d8d-461d-a758-5d2296c2b4a0",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e86ee505-8d8d-461d-a758-5d2296c2b4a0",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f2081216-a40b-4991-9f60-5dbb3bf4b273",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f2081216-a40b-4991-9f60-5dbb3bf4b273",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f2081216-a40b-4991-9f60-5dbb3bf4b273",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d293f783-2f93-4378-ba37-5e12f1ba24d1",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d293f783-2f93-4378-ba37-5e12f1ba24d1",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d293f783-2f93-4378-ba37-5e12f1ba24d1",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "02843c32-7ef1-4043-a582-5f97d0d4545e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "02843c32-7ef1-4043-a582-5f97d0d4545e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "02843c32-7ef1-4043-a582-5f97d0d4545e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fe123629-fc86-4c95-bea7-633fa36b58da",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fe123629-fc86-4c95-bea7-633fa36b58da",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fe123629-fc86-4c95-bea7-633fa36b58da",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3328b401-3584-450e-99f2-6390b8043bab",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3328b401-3584-450e-99f2-6390b8043bab",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3328b401-3584-450e-99f2-6390b8043bab",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "51be8f0b-9643-4bd1-956c-6a9737b81768",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "51be8f0b-9643-4bd1-956c-6a9737b81768",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "51be8f0b-9643-4bd1-956c-6a9737b81768",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "40fbd4a7-9558-46a1-98a4-6b160e9bb63c",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "40fbd4a7-9558-46a1-98a4-6b160e9bb63c",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "40fbd4a7-9558-46a1-98a4-6b160e9bb63c",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08ad1a85-daaf-489b-8174-6c4613228d36",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08ad1a85-daaf-489b-8174-6c4613228d36",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08ad1a85-daaf-489b-8174-6c4613228d36",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ab2fc33d-0da8-4679-b97a-6c4e771ce8a9",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ab2fc33d-0da8-4679-b97a-6c4e771ce8a9",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ab2fc33d-0da8-4679-b97a-6c4e771ce8a9",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e84cd44a-970b-4e7c-ac20-72082aa13cef",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e84cd44a-970b-4e7c-ac20-72082aa13cef",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e84cd44a-970b-4e7c-ac20-72082aa13cef",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9402ed10-5961-49bd-8879-73109983a369",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9402ed10-5961-49bd-8879-73109983a369",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9402ed10-5961-49bd-8879-73109983a369",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "559a7fb8-077c-4f81-9d34-73ef9dad1ba1",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "559a7fb8-077c-4f81-9d34-73ef9dad1ba1",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "559a7fb8-077c-4f81-9d34-73ef9dad1ba1",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "354c1711-1b3d-410a-8caa-776fe13c0eaf",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "354c1711-1b3d-410a-8caa-776fe13c0eaf",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "354c1711-1b3d-410a-8caa-776fe13c0eaf",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "52dc9d41-fb0f-4b1d-874b-790bc2b10651",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "52dc9d41-fb0f-4b1d-874b-790bc2b10651",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "52dc9d41-fb0f-4b1d-874b-790bc2b10651",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "16f52ab4-a1c6-41f1-a0c7-7a963a9732c7",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "16f52ab4-a1c6-41f1-a0c7-7a963a9732c7",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "16f52ab4-a1c6-41f1-a0c7-7a963a9732c7",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3bb4f78b-14cd-43f0-b77f-7cb73aed2969",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3bb4f78b-14cd-43f0-b77f-7cb73aed2969",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3bb4f78b-14cd-43f0-b77f-7cb73aed2969",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4eec87e6-9c28-48c3-ad43-7eebd2621d99",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4eec87e6-9c28-48c3-ad43-7eebd2621d99",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4eec87e6-9c28-48c3-ad43-7eebd2621d99",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "784901c3-d252-4da6-859e-8039ca9551af",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "784901c3-d252-4da6-859e-8039ca9551af",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "784901c3-d252-4da6-859e-8039ca9551af",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e74e6e98-6314-4c57-8a1b-827a463f8098",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e74e6e98-6314-4c57-8a1b-827a463f8098",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "e74e6e98-6314-4c57-8a1b-827a463f8098",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f36f2086-f093-465b-abed-8535cdae4353",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f36f2086-f093-465b-abed-8535cdae4353",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f36f2086-f093-465b-abed-8535cdae4353",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d15d953-226e-4298-8f20-88ad568fedf5",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d15d953-226e-4298-8f20-88ad568fedf5",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8d15d953-226e-4298-8f20-88ad568fedf5",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d1778d33-b170-4f2d-b93b-88dc5f53d0e6",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d1778d33-b170-4f2d-b93b-88dc5f53d0e6",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d1778d33-b170-4f2d-b93b-88dc5f53d0e6",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6c599207-51b4-491c-8e5f-8b8d018772f3",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6c599207-51b4-491c-8e5f-8b8d018772f3",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6c599207-51b4-491c-8e5f-8b8d018772f3",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bc765a3e-de8c-4241-9140-8da026706bf9",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bc765a3e-de8c-4241-9140-8da026706bf9",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bc765a3e-de8c-4241-9140-8da026706bf9",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f311cb52-52b7-43ba-9a07-8da6a6472535",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f311cb52-52b7-43ba-9a07-8da6a6472535",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f311cb52-52b7-43ba-9a07-8da6a6472535",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "86332aea-29c8-46e8-9650-8f0c53ef3405",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "86332aea-29c8-46e8-9650-8f0c53ef3405",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "86332aea-29c8-46e8-9650-8f0c53ef3405",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98075cce-ced2-42b6-a47f-8fbb905fd31e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98075cce-ced2-42b6-a47f-8fbb905fd31e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "98075cce-ced2-42b6-a47f-8fbb905fd31e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3688487c-a812-4526-999c-9040f0e0d97e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3688487c-a812-4526-999c-9040f0e0d97e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3688487c-a812-4526-999c-9040f0e0d97e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a8ae7721-ae2b-4ecb-bf0e-90b557750615",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a8ae7721-ae2b-4ecb-bf0e-90b557750615",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a8ae7721-ae2b-4ecb-bf0e-90b557750615",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d3876d7b-047f-4821-8dfb-9238bca4002f",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d3876d7b-047f-4821-8dfb-9238bca4002f",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d3876d7b-047f-4821-8dfb-9238bca4002f",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0fc8470b-fb80-4d10-a798-9416702792f7",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0fc8470b-fb80-4d10-a798-9416702792f7",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0fc8470b-fb80-4d10-a798-9416702792f7",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "364a0054-21c8-4fad-8205-946b81bf1450",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "364a0054-21c8-4fad-8205-946b81bf1450",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "364a0054-21c8-4fad-8205-946b81bf1450",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1057a63e-361e-4349-b50e-952802614da4",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1057a63e-361e-4349-b50e-952802614da4",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1057a63e-361e-4349-b50e-952802614da4",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9a721bd9-b9dd-4b44-aaba-961c97944e9a",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9a721bd9-b9dd-4b44-aaba-961c97944e9a",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9a721bd9-b9dd-4b44-aaba-961c97944e9a",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8a441c85-b38f-44bb-99b6-96b137f783ed",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8a441c85-b38f-44bb-99b6-96b137f783ed",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "8a441c85-b38f-44bb-99b6-96b137f783ed",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4562b7e7-4f33-4382-909e-99365404dd49",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4562b7e7-4f33-4382-909e-99365404dd49",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4562b7e7-4f33-4382-909e-99365404dd49",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c9f0ded3-bcb3-46ed-882a-9a08b3486e90",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c9f0ded3-bcb3-46ed-882a-9a08b3486e90",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c9f0ded3-bcb3-46ed-882a-9a08b3486e90",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aa438ece-e379-453a-8420-9a92620a34a2",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aa438ece-e379-453a-8420-9a92620a34a2",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aa438ece-e379-453a-8420-9a92620a34a2",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "befe6305-6bae-4651-a061-9aa47d72956c",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "befe6305-6bae-4651-a061-9aa47d72956c",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "befe6305-6bae-4651-a061-9aa47d72956c",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2cfa604a-34b3-4463-9e72-9ce8810c2891",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2cfa604a-34b3-4463-9e72-9ce8810c2891",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2cfa604a-34b3-4463-9e72-9ce8810c2891",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac31de83-c06a-4ab1-96df-9d867dfbd25e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac31de83-c06a-4ab1-96df-9d867dfbd25e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ac31de83-c06a-4ab1-96df-9d867dfbd25e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "34d3fcf3-d1ec-4e98-8874-9f7cfe8fafde",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "34d3fcf3-d1ec-4e98-8874-9f7cfe8fafde",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "34d3fcf3-d1ec-4e98-8874-9f7cfe8fafde",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90ce491e-dfc5-4631-a5d2-9f8575cc8ff7",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90ce491e-dfc5-4631-a5d2-9f8575cc8ff7",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "90ce491e-dfc5-4631-a5d2-9f8575cc8ff7",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "تقرير تحليل الفجوة لنظام إدارة الجودة",
      "StartDate": "2021-09-05T00:00:00",
      "FinishDate": "2021-10-31T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "تدريب المراجعين الداخليين لنظام إدارة الجودة الأيزو 9001",
      "StartDate": "2022-03-06T00:00:00",
      "FinishDate": "2022-03-31T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "الحصول على شهادات الاعتماد",
      "StartDate": "2022-05-01T00:00:00",
      "FinishDate": "2022-06-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "تسليم النظام الإلكتروني لإدارة الإجراءات الرئيسية لنظام إدارة الجودة وفق الشروط المحددة",
      "StartDate": "2022-02-01T00:00:00",
      "FinishDate": "2022-04-01T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "تسليم وثائق نظام إدارة الجودة وفق الشروط المحددة ISO9001",
      "StartDate": "2021-11-01T00:00:00",
      "FinishDate": "2022-02-28T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9deba39f-29a0-4da4-9c6f-9f993504ad6b",
      "Title": "توفير وتسجيل وتفعيل الرخص والبرامج",
      "StartDate": "2022-02-01T00:00:00",
      "FinishDate": "2022-04-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "72532029-151c-46f3-8908-a01d19a55673",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "72532029-151c-46f3-8908-a01d19a55673",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "72532029-151c-46f3-8908-a01d19a55673",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8a13b29-0942-44a8-850b-a01fa70dc82a",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8a13b29-0942-44a8-850b-a01fa70dc82a",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8a13b29-0942-44a8-850b-a01fa70dc82a",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a6780654-47af-425f-8161-a02ac70a50c3",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a6780654-47af-425f-8161-a02ac70a50c3",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a6780654-47af-425f-8161-a02ac70a50c3",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08d6e11e-9831-4c65-9f01-a14ffedf4804",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08d6e11e-9831-4c65-9f01-a14ffedf4804",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "08d6e11e-9831-4c65-9f01-a14ffedf4804",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "744dba59-78da-4795-bb2f-a64a5a65cc96",
      "Title": "اقفال المشاريع المكتملة و الغير مغلقة",
      "StartDate": "2021-04-11T00:00:00",
      "FinishDate": "2021-10-31T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "830de3c2-3b5a-4a6f-9182-a722d089a461",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "830de3c2-3b5a-4a6f-9182-a722d089a461",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "830de3c2-3b5a-4a6f-9182-a722d089a461",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c4644123-e720-4c93-aa0b-a86cd0a5caeb",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c4644123-e720-4c93-aa0b-a86cd0a5caeb",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c4644123-e720-4c93-aa0b-a86cd0a5caeb",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7f180db-d9fe-43aa-a2a9-aa9711668343",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7f180db-d9fe-43aa-a2a9-aa9711668343",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7f180db-d9fe-43aa-a2a9-aa9711668343",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0a50c635-6cf7-4fc2-9bde-ab064b08dff7",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0a50c635-6cf7-4fc2-9bde-ab064b08dff7",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0a50c635-6cf7-4fc2-9bde-ab064b08dff7",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6058e92b-d462-4f61-bb13-ab1a5bac2963",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6058e92b-d462-4f61-bb13-ab1a5bac2963",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "6058e92b-d462-4f61-bb13-ab1a5bac2963",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f57f844-6b81-40b9-b7e6-ac0b4f40e721",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f57f844-6b81-40b9-b7e6-ac0b4f40e721",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2f57f844-6b81-40b9-b7e6-ac0b4f40e721",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a94efbb7-1bff-4e46-9182-afb7c50ee688",
      "Title": "الحوكمة 10",
      "StartDate": "2021-03-01T08:00:00",
      "FinishDate": "2021-03-05T17:00:00",
      "TaskDuration": 40,
      "TaskPercentCompleted": 60,
      "TaskActualStartDate": "2021-03-01T08:00:00",
      "TaskBaseline0StartDate": "2021-03-01T08:00:00",
      "TaskBaseline0FinishDate": "2021-03-05T17:00:00",
      "TaskStatus": "متأخر",
      "TaskDelay": 356
    },
    {
      "ProjectUID": "a94efbb7-1bff-4e46-9182-afb7c50ee688",
      "Title": "تقييم الوضع الراهن للقطاعات",
      "StartDate": "2021-02-22T08:00:00",
      "FinishDate": "2021-02-26T17:00:00",
      "TaskDuration": 40,
      "TaskPercentCompleted": 20,
      "TaskActualStartDate": "2021-02-22T08:00:00",
      "TaskBaseline0StartDate": "2021-02-22T08:00:00",
      "TaskBaseline0FinishDate": "2021-02-26T17:00:00",
      "TaskStatus": "متأخر",
      "TaskDelay": 363
    },
    {
      "ProjectUID": "a94efbb7-1bff-4e46-9182-afb7c50ee688",
      "Title": "لوحات الاداء والتقارير",
      "StartDate": "2021-03-15T08:00:00",
      "FinishDate": "2021-03-19T17:00:00",
      "TaskDuration": 40,
      "TaskPercentCompleted": 70,
      "TaskActualStartDate": "2021-03-15T08:00:00",
      "TaskBaseline0StartDate": "2021-03-15T08:00:00",
      "TaskBaseline0FinishDate": "2021-03-23T12:00:00",
      "TaskStatus": "متأخر",
      "TaskDelay": 338
    },
    {
      "ProjectUID": "66d81aeb-1973-4b97-8e2b-b12e0905232b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "66d81aeb-1973-4b97-8e2b-b12e0905232b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "66d81aeb-1973-4b97-8e2b-b12e0905232b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebed4df2-716f-4a67-a2cd-b36e1a02d2de",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebed4df2-716f-4a67-a2cd-b36e1a02d2de",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ebed4df2-716f-4a67-a2cd-b36e1a02d2de",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4c07e98-a349-48c7-9a7e-b5fd856686ed",
      "Title": "قطاع النمويل",
      "StartDate": "2020-12-24T08:00:00",
      "FinishDate": "2020-12-25T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4c07e98-a349-48c7-9a7e-b5fd856686ed",
      "Title": "قطاع المنشات",
      "StartDate": "2020-12-28T08:00:00",
      "FinishDate": "2020-12-29T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b4c07e98-a349-48c7-9a7e-b5fd856686ed",
      "Title": "قطاع الخدمات",
      "StartDate": "2020-12-22T08:00:00",
      "FinishDate": "2020-12-23T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ba000ba1-8931-4e4d-8182-b5fe7419f530",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ba000ba1-8931-4e4d-8182-b5fe7419f530",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ba000ba1-8931-4e4d-8182-b5fe7419f530",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2731ec7-6986-460f-a464-b66ccf371537",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2731ec7-6986-460f-a464-b66ccf371537",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d2731ec7-6986-460f-a464-b66ccf371537",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ad7c4b13-7c07-4966-8176-b6ad8916f6d8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ad7c4b13-7c07-4966-8176-b6ad8916f6d8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ad7c4b13-7c07-4966-8176-b6ad8916f6d8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "29d2f9d7-d85d-4d09-88ae-bd939b54d5bf",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "29d2f9d7-d85d-4d09-88ae-bd939b54d5bf",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "29d2f9d7-d85d-4d09-88ae-bd939b54d5bf",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "db25b574-5290-4bb9-8e2b-bff1309c4082",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "db25b574-5290-4bb9-8e2b-bff1309c4082",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "db25b574-5290-4bb9-8e2b-bff1309c4082",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3cdddb8-3992-4b02-bfb1-c0656719bb4f",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3cdddb8-3992-4b02-bfb1-c0656719bb4f",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f3cdddb8-3992-4b02-bfb1-c0656719bb4f",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ecb261c3-dfe2-4bca-b337-c3f9d752e330",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ecb261c3-dfe2-4bca-b337-c3f9d752e330",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ecb261c3-dfe2-4bca-b337-c3f9d752e330",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ff1f8b2d-200b-454b-8242-c5e0185c322b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ff1f8b2d-200b-454b-8242-c5e0185c322b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ff1f8b2d-200b-454b-8242-c5e0185c322b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bd2aaf27-843d-4ff6-adec-c7ba437005c6",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bd2aaf27-843d-4ff6-adec-c7ba437005c6",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bd2aaf27-843d-4ff6-adec-c7ba437005c6",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9ac3533b-cac4-4e36-bd79-c93098fd4c04",
      "Title": "تطوير الإجراءات الداخلية Workflow للعقود والمشتريات",
      "StartDate": "2021-06-02T00:00:00",
      "FinishDate": "2021-12-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7bb3be5-9078-4164-b23b-c93112153d81",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7bb3be5-9078-4164-b23b-c93112153d81",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "c7bb3be5-9078-4164-b23b-c93112153d81",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f637a84-6d8a-47be-8264-ca44d99a1f32",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f637a84-6d8a-47be-8264-ca44d99a1f32",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0f637a84-6d8a-47be-8264-ca44d99a1f32",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb5a5add-4fe1-427b-8c5e-caeb4af74259",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb5a5add-4fe1-427b-8c5e-caeb4af74259",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "bb5a5add-4fe1-427b-8c5e-caeb4af74259",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1de193f9-4964-4ac8-814f-cbff91d5f6c6",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1de193f9-4964-4ac8-814f-cbff91d5f6c6",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "1de193f9-4964-4ac8-814f-cbff91d5f6c6",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2703aff6-3ab5-48ba-b472-cdb74bc87497",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2703aff6-3ab5-48ba-b472-cdb74bc87497",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "2703aff6-3ab5-48ba-b472-cdb74bc87497",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d33b501b-9eb3-4886-935b-cdffb3182d30",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d33b501b-9eb3-4886-935b-cdffb3182d30",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d33b501b-9eb3-4886-935b-cdffb3182d30",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d44d103c-ceef-4bad-8d81-cf336d98afd8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d44d103c-ceef-4bad-8d81-cf336d98afd8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d44d103c-ceef-4bad-8d81-cf336d98afd8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b966c453-4e02-4c59-a679-d094fb20351f",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b966c453-4e02-4c59-a679-d094fb20351f",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b966c453-4e02-4c59-a679-d094fb20351f",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3db15a45-dc62-4ce1-bb18-d13e2acc27d8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3db15a45-dc62-4ce1-bb18-d13e2acc27d8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3db15a45-dc62-4ce1-bb18-d13e2acc27d8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fa834a0b-be0f-4e59-912d-d36abe058df3",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fa834a0b-be0f-4e59-912d-d36abe058df3",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "fa834a0b-be0f-4e59-912d-d36abe058df3",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d271d7c1-831b-4e4b-a5d5-d5eb4ae16ee8",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d271d7c1-831b-4e4b-a5d5-d5eb4ae16ee8",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d271d7c1-831b-4e4b-a5d5-d5eb4ae16ee8",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c2e39fb-0a47-431a-b1ea-e07aceb24df4",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c2e39fb-0a47-431a-b1ea-e07aceb24df4",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0c2e39fb-0a47-431a-b1ea-e07aceb24df4",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "270e875b-813c-48d4-b3e2-e22c2c2de9ea",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "270e875b-813c-48d4-b3e2-e22c2c2de9ea",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "270e875b-813c-48d4-b3e2-e22c2c2de9ea",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "060e96e7-0e6d-4f69-91cd-e273fa44de9d",
      "Title": "تطوير لوحة المؤشرات  الخاصة بالعقود Dashboard",
      "StartDate": "2021-05-02T00:00:00",
      "FinishDate": "2021-07-08T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d75f2841-9e20-49d8-b9b5-e31585cd90ba",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d75f2841-9e20-49d8-b9b5-e31585cd90ba",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "d75f2841-9e20-49d8-b9b5-e31585cd90ba",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9e904557-b1cd-4db6-963e-e39a7fd2fe3e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9e904557-b1cd-4db6-963e-e39a7fd2fe3e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "9e904557-b1cd-4db6-963e-e39a7fd2fe3e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0ac8fb1c-3065-4f97-9265-e3b4a8e7947c",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0ac8fb1c-3065-4f97-9265-e3b4a8e7947c",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "0ac8fb1c-3065-4f97-9265-e3b4a8e7947c",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "3079f6ba-ac0a-4750-849d-e3e50516395e",
      "Title": "توثيق سياسات وإجراءات البنك (50)",
      "StartDate": "2021-01-03T00:00:00",
      "FinishDate": "2021-09-30T00:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7d17dfb0-7199-4eac-b252-e4637f96eab6",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7d17dfb0-7199-4eac-b252-e4637f96eab6",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "7d17dfb0-7199-4eac-b252-e4637f96eab6",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b9fd60d6-88d6-4111-b12f-e542f9230d33",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b9fd60d6-88d6-4111-b12f-e542f9230d33",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b9fd60d6-88d6-4111-b12f-e542f9230d33",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df4e3ce7-e961-49e7-832e-e67ceb2d6055",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df4e3ce7-e961-49e7-832e-e67ceb2d6055",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "df4e3ce7-e961-49e7-832e-e67ceb2d6055",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b11a1a04-a646-4b95-8e44-ebcbe8f2754e",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b11a1a04-a646-4b95-8e44-ebcbe8f2754e",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b11a1a04-a646-4b95-8e44-ebcbe8f2754e",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "97521475-0dd1-4db3-b6a1-ec0840e5da40",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "97521475-0dd1-4db3-b6a1-ec0840e5da40",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "97521475-0dd1-4db3-b6a1-ec0840e5da40",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "74c0763b-b3e0-4ebc-8739-ec529926c66b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "74c0763b-b3e0-4ebc-8739-ec529926c66b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "74c0763b-b3e0-4ebc-8739-ec529926c66b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ed5a235c-03ca-41ea-b135-ef1f13bfe467",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ed5a235c-03ca-41ea-b135-ef1f13bfe467",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "ed5a235c-03ca-41ea-b135-ef1f13bfe467",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a16cf312-2060-4110-a465-f14f88b5d736",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a16cf312-2060-4110-a465-f14f88b5d736",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a16cf312-2060-4110-a465-f14f88b5d736",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a5b9537a-e1ba-4eff-91f5-f17612f552a5",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a5b9537a-e1ba-4eff-91f5-f17612f552a5",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a5b9537a-e1ba-4eff-91f5-f17612f552a5",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aabbdbc4-3ba0-482c-850f-f2aa6558b6b4",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aabbdbc4-3ba0-482c-850f-f2aa6558b6b4",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "aabbdbc4-3ba0-482c-850f-f2aa6558b6b4",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f4a6ca5a-03ea-46d7-b260-f5899faabecf",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f4a6ca5a-03ea-46d7-b260-f5899faabecf",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "f4a6ca5a-03ea-46d7-b260-f5899faabecf",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b55a7fc9-5724-4a56-8a39-f6375aa144a4",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b55a7fc9-5724-4a56-8a39-f6375aa144a4",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b55a7fc9-5724-4a56-8a39-f6375aa144a4",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8e5489c-b135-42e8-92ab-f6b638bc64d3",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8e5489c-b135-42e8-92ab-f6b638bc64d3",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "b8e5489c-b135-42e8-92ab-f6b638bc64d3",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a886c990-14c5-46a1-ae1a-fbed6b54f36b",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a886c990-14c5-46a1-ae1a-fbed6b54f36b",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "a886c990-14c5-46a1-ae1a-fbed6b54f36b",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4f733f59-0e37-487f-8271-fcd15bcedb86",
      "Title": "وضع تصور للنظام",
      "StartDate": "2021-03-04T08:00:00",
      "FinishDate": "2021-03-10T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4f733f59-0e37-487f-8271-fcd15bcedb86",
      "Title": "لوحات الاداء",
      "StartDate": "2021-03-11T09:00:00",
      "FinishDate": "2021-03-21T13:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    },
    {
      "ProjectUID": "4f733f59-0e37-487f-8271-fcd15bcedb86",
      "Title": "الحوكمة",
      "StartDate": "2021-02-25T08:00:00",
      "FinishDate": "2021-03-03T17:00:00",
      "TaskDuration": null,
      "TaskPercentCompleted": null,
      "TaskActualStartDate": null,
      "TaskBaseline0StartDate": null,
      "TaskBaseline0FinishDate": null,
      "TaskStatus": "حسب المخطط",
      "TaskDelay": 0
    }
  ];